// module/config/GIS_Config.js
import Vue from 'vue'

const topologyData = Vue.ls.get('GIS_TOPOLOGY_DATA') || {}
let topology = ''
let topologyProjection = ''
let topologyCode = ''

// 确保有有效的拓扑数据
if (topologyData && topologyData.topology) {
  topology = topologyData
  topologyProjection = topologyData.topology.projectCode
  topologyCode = topologyData.topology.code
}
let CONFIG = {
  // 服务器地址
  // GIS_URL:'http://172.16.6.162:8080' // 开发本地
  // GIS_URL: 'http://120.71.183.224:8080', // 测试服务器
  GIS_URL: 'https://eminview.xjzdcsyyyxzrgs.com', // 域名

  // GeoServer REST 认证配置（部署时按实际环境修改）
  GEO_SERVER_AUTH: {
    username: 'admin',
    password: 'WWww521025!',
  },

  // 工作区名称
  WORKSPACE: 'tp_data',

  // 投影系统
  PROJECTION: 'EPSG:3857',

  // 缓存拓扑结构
  Topology: topology, // 直接使用变量
  TopologyProjection: topologyProjection,
  TopologyCode: topologyCode,
  SLDStyle: {
    CUSTOMIZE_CONFIG_TYPE_NODE_ICON: 'CUSTOMIZE_CONFIG_TYPE_NODE_ICON', // 图标配置
    CUSTOMIZE_CONFIG_TYPE_LINE_COMMON: 'CUSTOMIZE_CONFIG_TYPE_LINE_COMMON', // 管径渲染配置
    CUSTOMIZE_CONFIG_TYPE_LINE_PRESSURE: 'CUSTOMIZE_CONFIG_TYPE_LINE_PRESSURE', // 压力渲染配置
    CUSTOMIZE_CONFIG_TYPE_ZOOM_LEVEL: 'CUSTOMIZE_CONFIG_TYPE_ZOOM_LEVEL', // 分级渲染配置
  },

  // 默认范围（降级使用）
  DEFAULT_EXTENT: [83.533098, 46.42201, 83.910157, 46.588895],

  // 瓦片矩阵集配置
  TILE_MATRIX_SET: {
    ID: 'EM_MAP_GRIDSET_3857',
    TILE_SIZE: [256, 256],
    RESOLUTIONS: (() => {
      const width = 20037508.34 * 2
      const resolutions = []
      for (let z = 0; z < 22; z++) {
        resolutions.push(width / (256 * Math.pow(2, z)))
      }
      return resolutions
    })(),
    MATRIX_IDS: (() => {
      const matrixIds = []
      for (let z = 0; z < 22; z++) {
        matrixIds.push(`GRIDSET_3857:${z}`)
      }
      return matrixIds
    })(),
  },

  // 图层服务路径
  SERVICE_PATHS: {
    WMS: workspace => `${CONFIG.GIS_URL}/geoserver/${workspace}/wms`,
    WFS: workspace => `${CONFIG.GIS_URL}/geoserver/${workspace}/wfs`,
    WMTS_BASE: workspace => `${CONFIG.GIS_URL}/geoserver/${workspace}/gwc/service/wmts`,
    WMTS_TILE: {
      EM_MAP: (matrixSet, z, y, x) =>
        `${CONFIG.GIS_URL}/geoserver/${CONFIG.WORKSPACE}/gwc/service/wmts/rest/em_all_data/line/${matrixSet}/${matrixSet}:${z}/${y}/${x}?format=image/png`,
      TOPOLOGY: (matrixSet, z, y, x) =>
        `${CONFIG.GIS_URL}/geoserver/gwc/service/wmts/rest/em_all_data/line/${matrixSet}/${matrixSet}:${z}/${y}/${x}?format=image/png`,
    },
    SLD_URL: styleCode => `${CONFIG.GIS_URL}/geoserver/rest/workspaces/${CONFIG.WORKSPACE}/styles/${styleCode}`,
  },

  // 图层参数配置
  LAYER_PARAMS: {
    WMTS_BASE: {
      format: 'image/png',
      projection: 'EPSG:3857',
      matrixSet: 'EM_MAP_GRIDSET_3857',
    },

    WMS_BASE: {
      FORMAT: 'image/png',
      TRANSPARENT: true,
      serverType: 'geoserver',
      ratio: 1,
      projection: 'EPSG:3857',
    },

    SPECIFIC: {
      EM_MAP_ALL_18: {
        name: 'tp_data:EM_MAP_ALL_18',
        style: 'line',
        tileUrlTemplate: (matrixSet, z, x, y) => CONFIG.SERVICE_PATHS.WMTS_TILE.EM_MAP(matrixSet, z, y, x),
      },
      EM_MAP_LEVEL_18_ST: {
        name: 'tp_data:EM_MAP_LEVEL_18_ST',
        style: 'line',
        tileUrlTemplate: (matrixSet, z, x, y) => CONFIG.SERVICE_PATHS.WMTS_TILE.EM_MAP(matrixSet, z, y, x),
      },
      EM_TOPOLOGY: {
        name: 'em_all_data',
        style: 'line',
        tileUrlTemplate: (matrixSet, z, x, y) => CONFIG.SERVICE_PATHS.WMTS_TILE.TOPOLOGY(matrixSet, z, y, x),
      },
      TP_NODE: {
        LAYERS: 'tp_data:tp_node_sql',
        Style: 'CUSTOMIZE_CONFIG_TYPE_NODE_ICON',
      },
      TP_PIPELINE: {
        LAYERS: 'tp_data:tp_pipeline_sql',
        Style: 'CUSTOMIZE_CONFIG_TYPE_LINE_COMMON',
      },
      TP_AREA: {
        LAYERS: 'tp_data:tp_area_sql',
        Style: '',
      },
    },
  },
}

export function updateTopology() {
  const topologyData = Vue.ls.get('GIS_TOPOLOGY_DATA') || {}
  // 确保有有效的拓扑数据
  if (topologyData && topologyData.topology) {
    CONFIG.Topology = topologyData
    CONFIG.TopologyProjection = topologyData.topology.projectCode
    CONFIG.TopologyCode = topologyData.topology.code
  }
}
export default CONFIG
